import { render, staticRenderFns } from "./tmVisualEmptyScene.vue?vue&type=template&id=3c7c44e3&"
import script from "./tmVisualEmptyScene.vue?vue&type=script&lang=js&"
export * from "./tmVisualEmptyScene.vue?vue&type=script&lang=js&"
import style0 from "./tmVisualEmptyScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports